module.exports = __webpack_public_path__ + "static/media/pf31.69968362.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf31.png
// module id = 1068
// module chunks = 0